import { Icon, SvgIconNames } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './EarningsInsightTypePill.styles';
import { constructMetadataSentence } from './utils';

export interface EarningsInsightTypePillProps {
  insightType: 'preview' | 'recap';
  iconName: SvgIconNames;
  publishedDate?: Date;
  updatedTime?: Date;
  periods?: string;
  releasedDate?: Date;
  isDrawer?: boolean;
}

const INSIGHT_CONFIG = {
  preview: {
    iconColor: 'var(--icon-decorative-purple)',
    translationKey: 'earnings:earningsInsight.drawer.earningsPreview.title',
  },
  recap: {
    iconColor: 'var(--icon-decorative-teal)',
    translationKey: 'earnings:earningsInsight.drawer.earningsRecap.title',
  },
} as const;

export const EarningsInsightTypePill = ({
  insightType,
  iconName,
  publishedDate,
  updatedTime,
  periods,
  releasedDate,
  isDrawer = false,
}: EarningsInsightTypePillProps) => {
  const { t } = useTranslation(['earnings']);
  const isPreview = insightType === 'preview';
  const config = INSIGHT_CONFIG[insightType];

  return (
    <S.Container>
      <S.LabelWrapper $isPreview={isPreview}>
        <Icon iconName={iconName} size={12} fillColor={config.iconColor} />
        <S.Label $isPreview={isPreview}>{t(config.translationKey)}</S.Label>
      </S.LabelWrapper>
      {isDrawer && publishedDate && (
        <S.MetadataText>
          {constructMetadataSentence({
            publishedDate,
            updatedTime,
            periods,
            releasedDate,
            isPreview,
            t,
          })}
        </S.MetadataText>
      )}
    </S.Container>
  );
};
